import CustomDropdown from '@/components/CustomDropdown';

import { fabricLineFromDropdown, isBlankMissing, labelOrValue, dropdownSelectionFromItem } from '../utils';

const UpdateTechpackInfoForm = ({
	selectedProductId,
	buyerDesignNoInput,
	onBuyerDesignNoChange,
	marketList,
	marketSelection,
	onMarketSelection,
	categorySubCategoryList,
	categorySelection,
	onCategorySelection,
	printList,
	printSelection,
	onPrintSelection,
	embroideryList,
	embroiderySelection,
	onEmbroiderySelection,
	washList,
	washSelection,
	onWashSelection,
	metarialFabricList,
	metarialFabricSelection,
	onMetarialFabricSelection,
	onGetBodyFabrics,
	selectedFabricInfoValue,
	selectedFabricationFields,
	onOpenMissingFabricModal,
	setIsUpdateFormToggle,
	onSave
}) => {
	const formDisabled = selectedProductId == null;
	const fabricLine = fabricLineFromDropdown(metarialFabricSelection?.value, selectedFabricationFields);
	const hasFabricRowContext = Boolean(selectedFabricationFields);

	const renderFabricLineInfo = () => {
		return (
			<ul className="d-flex justify-content-start align-items-center flex-wrap gap-1 mb-0 list-unstyled">
				<li className="regular-14 d-flex flex-wrap align-items-center gap-1 mb-0">
					{fabricLine.map(([label, value], i) => (
						<span key={label}>
							{i > 0 ? <span className="gray_dark_01">, </span> : null}
							{!hasFabricRowContext ? (
								isBlankMissing(value) ? (
									<span className="gray_dark_01">
										{label}
										<span className="gray_dark_03"> —</span>
									</span>
								) : (
									<span className="gray_dark_01">{labelOrValue(value, label)}</span>
								)
							) : isBlankMissing(value) ? (
								<span className="red">{label}</span>
							) : (
								<span className="gray_dark_01">{labelOrValue(value, label)}</span>
							)}
						</span>
					))}
				</li>
			</ul>
		);
	};

	return (
		<div className="update-tp-info-form mt-12 mb-3">
			<div className="header d-flex justify-content-between align-items-start">
				<h3 className="semibold-16 gray_dark_01">Update techpack info</h3>
			</div>
			<div className="update-tp-info-form-body bg-white border">
				<div className="row">
					<div className="col-md-12">
						<p className="semibold-14 gray_dark_01 mb-2">Basic info</p>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-buyer-design-no">Buyer design no</label>
							<input
								type="text"
								className="form-control"
								id="tp-buyer-design-no"
								value={buyerDesignNoInput}
								onChange={(e) => onBuyerDesignNoChange(e.target.value)}
								disabled={formDisabled}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-market-dd">Market</label>
							<CustomDropdown
								title="Select"
								items={marketList.map((item) => ({ id: item.id, value: item.name }))}
								isShowSearch={true}
								selectedItem={marketSelection?.value}
								onItemClick={(item) => onMarketSelection(dropdownSelectionFromItem(item))}
								isDisabled={formDisabled}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-category-dd">Category</label>
							<CustomDropdown
								title="Select"
								toolTipLength={13}
								items={categorySubCategoryList.flatMap((item) =>
									(item?.subCategoryResponseList || []).map((subCategory) => ({
										id: subCategory.id,
										value: subCategory.name,
										isPrimary: subCategory.isPrimary
									}))
								)}
								isShowSearch={true}
								selectedItem={categorySelection?.value}
								onItemClick={(item) => onCategorySelection(dropdownSelectionFromItem(item))}
								isDisabled={formDisabled}
								position="right"
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<p className="semibold-14 gray_dark_01 mb-2">Embellishment</p>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-print-dd">Print</label>
							<CustomDropdown
								title="Select"
								items={printList.map((item) => ({ id: item.id, value: item.name }))}
								isShowSearch={true}
								selectedItem={printSelection?.value}
								onItemClick={(item) => onPrintSelection(dropdownSelectionFromItem(item))}
								isDisabled={formDisabled}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-embroidery-dd">Embroidery</label>
							<CustomDropdown
								title="Select"
								toolTipLength={13}
								items={embroideryList.map((item) => ({
									id: item.id,
									value: item.name
								}))}
								isShowSearch={true}
								selectedItem={embroiderySelection?.value}
								onItemClick={(item) => onEmbroiderySelection(dropdownSelectionFromItem(item))}
								isDisabled={formDisabled}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="tp-wash-dd">Wash</label>
							<CustomDropdown
								title="Select"
								toolTipLength={13}
								items={washList.map((item) => ({ id: item.id, value: item.name }))}
								selectedItem={washSelection?.value}
								isShowSearch={true}
								onItemClick={(item) => onWashSelection(dropdownSelectionFromItem(item))}
								isDisabled={formDisabled}
								position="right"
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<p className="semibold-14 gray_dark_01 mb-2">Fabrication</p>
					</div>
					<div className="col-md-12">
						<div className="form-group">
							<label htmlFor="tp-fabric-dd">Fabrication</label>
							<CustomDropdown
								title="Select"
								items={metarialFabricList.map((item, index) => ({
									id: item?.id ?? index,
									fabricId: item?.id,
									value: item?.name
								}))}
								isShowSearch={true}
								onItemSearch={(value) => onGetBodyFabrics(value)}
								selectedItem={
									metarialFabricSelection?.value || selectedFabricInfoValue || undefined
								}
								onItemClick={(item) =>
									onMetarialFabricSelection(dropdownSelectionFromItem(item))
								}
								isDisabled={formDisabled}
							/>
						</div>
					</div>
					<div className="col-md-12">
						<div className="d-flex justify-content-start align-items-center gap-2">
							<p
								className="text-underline regular-14 cursor-pointer"
								onClick={onOpenMissingFabricModal}
							>
								Update missing fabric info:
							</p>
							{renderFabricLineInfo()}
						</div>
					</div>
				</div>
				<div className="tp-upadate-form-btn button-container d-flex justify-content-end align-items-center gap-2 mt-12">
					<button type="button" className="button primary size32" onClick={onSave}>
						Update
					</button>
					<button
						type="button"
						className="button gray-outline size32"
						onClick={() => setIsUpdateFormToggle(false)}
					>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
};

export default UpdateTechpackInfoForm;
